import {
  type PaymentMethodParams,
  apiRoutes,
  getPaymentMethodsByCustomersFn,
  type DefaultQueryError,
  type PaymentMethod,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetPaymentMethods = (
  params: PaymentMethodParams,
  opts?: Omit<UseQueryOptions<PaymentMethod[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<PaymentMethod[], DefaultQueryError>({
    queryKey: [apiRoutes.payment.order, params],
    queryFn: () => getPaymentMethodsByCustomersFn(params),
    ...opts,
  });
